<template>
  <ol class="docs-steps">
    <li>Fill in your details in the generator and click <b>Copy Signature</b>.</li>
    <li>In Outlook open <b>Outlook → Settings</b> (<kbd class="docs-kbd">⌘ ,</kbd>) and select <b>Signatures</b>.</li>
    <li>Click the <b>+</b> button to add a new signature.</li>
    <li>Right-click inside the editor and choose <b>Paste</b> (not “Paste as Plain Text”).</li>
    <li>Click the <b>Untitled</b> field and rename the signature (e.g. “No. J Signature”).</li>
    <li>
      Under <b>Set default signatures</b> pick the new signature for <b>For new messages</b>
      and <b>For replies or forwards</b>.
    </li>
    <li>Close the Settings window and click <b>New Email</b> to check the result.</li>
  </ol>
  <p class="docs-note">
    On Windows, or on the legacy Mac app (with the <b>New Outlook</b> switch turned off), follow the
    <a href="#outlook-legacy" class="underline">Windows / Mac legacy guide</a> instead.
  </p>
</template>
